const showVideo = () => {
  let hash = window.location.hash
  if(hash.indexOf('#video') >= 0) {
    let $video = document.querySelector('#video')
    if(!$video) return
    $video.click()
  }
}

const triggerVideo = () => {
  showVideo()
}

export default triggerVideo
